import { Button, Modal, Space, Typography } from 'antd';
import { Notice } from './Notice';

const { Text } = Typography;

interface LegalConsentBlockingModalProps {
  open: boolean;
  onClose: () => void;
  onReview: () => void;
}

export default function LegalConsentBlockingModal({ open, onClose, onReview }: LegalConsentBlockingModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Aceite obrigatório pendente"
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Notice
          type="warning"
          showIcon
          message="Para continuar, aceite os termos vigentes"
          description="Identificamos que seu aceite de Termos de Uso e/ou Política de Privacidade está desatualizado."
        />
        <Text>
          Este bloqueio afeta ações protegidas como responder pesquisas e enviar formulários.
        </Text>
        <Space>
          <Button onClick={onClose}>Fechar</Button>
          <Button type="primary" onClick={onReview}>
            Revisar e aceitar
          </Button>
        </Space>
      </Space>
    </Modal>
  );
}
